import type { AgentIconType } from './agentIconType';

/**
 * How an agent's hexagon reads against the page surface behind it.
 *
 * - `light` — a white or near-white tile, which disappears on light surfaces.
 * - `dark` — a black or near-black tile, which disappears on dark surfaces.
 * - `neutral` — a mid-tone brand color that holds against both surfaces.
 * - `adaptive` — the tile inverts with the color mode, so it always contrasts.
 */
export type AgentBrandTone = 'light' | 'dark' | 'neutral' | 'adaptive';

const AGENT_BRAND_TONE: Partial<Record<AgentIconType, AgentBrandTone>> = {
	chatgpt: 'dark',
	claude: 'neutral',
	codex: 'light',
	cursor: 'dark',
	figma: 'dark',
	lovable: 'dark',
	replit: 'dark',
	rovo: 'adaptive',
};

/**
 * Unmapped agents fall back to `neutral` so a new brand renders without a contrast stroke rather
 * than with the wrong one.
 */
export const getAgentBrandTone = (agentIcon: AgentIconType | undefined): AgentBrandTone =>
	(agentIcon && AGENT_BRAND_TONE[agentIcon]) ?? 'neutral';
